import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { seFeIconEnvelope, SeFeIconModule } from 'se-fe-icon'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { EmailComponent } from './email/email.component'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeIconModule.include([
      seFeIconEnvelope
    ]),
    SeFeTranslationsModule
  ],
  declarations: [
    EmailComponent
  ],
  exports: [
    EmailComponent
  ]
})
export class SharedUiEmailModule {}
